"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomData = void 0;
var utils_1 = require("./utils");
var utm_1 = require("./utm");
var CustomData = /** @class */ (function () {
    function CustomData() {
        var _a;
        this.Referrer = document.referrer;
        this.utm_last = (0, utm_1.getUTMCookie)();
        this.url = document.location.href;
        this.Country = (0, utils_1.getCookie)("country");
        this.user_id = (0, utils_1.getCookie)("user_id");
        var ua = (_a = window.navigator.userAgent) === null || _a === void 0 ? void 0 : _a.toLowerCase();
        this.platform = (0, utils_1.matchPlatform)(ua)[0] || "";
    }
    return CustomData;
}());
exports.CustomData = CustomData;
